/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $InspectionSummaries = {
    type: 'array',
    contains: {
        type: 'InspectionSummary',
    },
};